module.exports = __webpack_public_path__ + "2199aad8244e419abdb534998aec0ba6.png";